import * as _ from 'underscore';

// Models
import { IJourneyContactField } from 'Content/ts/Models/Join/Interfaces/IJourneyContactField';

class ContactFieldService {
    getFieldProperties(element: HTMLElement, contactFieldMapping: any) {
        var entity = element.getAttribute('entity');
        var ident = element.getAttribute('identifier');
        var type = element.getAttribute('type');
        var props = {
            visible: false,
            required: false
        };

        var group = contactFieldMapping[entity];
        var findParams = (type) ? { Identifier: ident, TypeId: Number(type) } : { Identifier: ident };

        if (group) {
            var field = _.findWhere(group, findParams) as IJourneyContactField;
            if (field) {
                // field found in config
                props.visible = true;
                props.required = field.Mandatory;
            }
        }

        return props;
    };
}

var service = new ContactFieldService();
export { service as ContactFieldService };